<template>
  <div>
    <el-card>
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>
            <span>Visit date：{{ formData.visitDate }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>{{ formData.visitTitle }}</span>
          </h6>
          <div>
            <span class="table-text"
              >Supplier：{{ formData.scmCodeName }}
            </span>
            <el-divider direction="vertical"></el-divider>
            <span class="table-text"
              >Score：{{ formData.scoreByName }} at
              {{ formData.scoreTime }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span class="table-text">考评总分：</span>
            <span class="table-text"
              ><b>{{ totalTopScore }}</b></span
            >
            <el-divider direction="vertical"></el-divider>
            <span class="table-text">本次得分：</span>
            <span style="color: #007bff"
              ><b>{{ totalScmScore }}</b></span
            >
          </div>
        </b-col>
      </b-row>
    </el-card>
    <el-card class="mt-2">
      <b-row>
        <b-col cols="auto" class="mr-auto">
          <h6>{{ formData.appraisalBillName }}</h6>
        </b-col>
        <b-col cols="auto">
          <a v-b-toggle.collapse-rating role="button" style="color: #606266">
            <i
              v-if="isShowRatingPanel"
              class="fa fa-chevron-down"
              title="收起"
            ></i>
            <i v-else class="fa fa-chevron-up" title="展开"></i>
          </a>
        </b-col>
      </b-row>
      <b-collapse v-model="isShowRatingPanel" id="collapse-rating">
        <b-row>
          <b-col>
            <el-timeline
              style="padding: 0px"
              class="mt-3"
              v-if="visitScoreCode"
            >
              <el-form ref="form">
                <Score
                  ref="scoreList"
                  :listVisitScoreGroup="formData.listVisitScoreGroup"
                />
              </el-form>
            </el-timeline>
          </b-col>
        </b-row>
        <!--按钮-->
        <div class="d2-mt">
          <el-row>
            <el-col :span="20">
              <el-button @click="del()" type="danger" size="small">{{
                $l('INDEX.btn_tips_del') || '删除'
              }}</el-button>
              <el-button
                @click="save"
                v-if="!isEditlock"
                size="small"
                type="primary"
              >
                {{ $l('INDEX.btn_save') || '保存' }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </b-collapse>
    </el-card>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import Score from '@/views/digital/components/score'

export default {
  name:'personal-myScmInfo-myVisit-rating-edit',
  components: {
    Score,
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      isShowRatingPanel: true,
      isEditlock: false,
      options: {
        lock: true,
        text: 'Loading...',
        background: 'rgba(0,0,0,0.5)',
      },
      visitScoreCode: '',
      formData: {
        visitScoreCode: '',
        visitCode: '',
        visitTitle: '',
        scmCode: '',
        scmCodeName: '',
        appraisalBillCode: '',
        appraisalBillName: '',
        visitScoreStatus: '',
        visitScoreStatusName: '',
        scoreBy: '',
        scoreByName: '',
        scoreTime: '',
        listVisitScoreGroup: [],
      },
    }
  },
  computed: {
    totalTopScore: function() {
      let totTopScore = 0
      let group = this.formData.listVisitScoreGroup
      if (group != null) {
        group.forEach((element) => {
          totTopScore += element.appraisalGroupTopScore
        })
      }
      return totTopScore
    },
    totalScmScore: function() {
      let totScmScore = 0
      let group = this.formData.listVisitScoreGroup
      if (group != null) {
        group.forEach((element) => {
          totScmScore += element.visitGroupScore
        })
      }
      return totScmScore
    },
  },
  mounted() {
    if (this.$route.params.visitScoreCode) {
      let type = this.$route.params.pageType
      this.visitScoreCode = this.$route.params.visitScoreCode
      this.init(type)
    }
  },
  // activated() {
  //   if (this.$route.params.visitScoreCode) {
  //     let type = this.$route.params.pageType
  //     this.visitScoreCode = this.$route.params.visitScoreCode
  //     this.init(type)
  //   }
  // },
  methods: {
    ...mapActions('admin/page', ['close']),
    init(type) {
      if (this.loading) {
        return
      }
      this.detailLoad()
    },
    detailLoad() {
      this.loading = true
      let param = { visitScoreCode: this.visitScoreCode }
      this.$api
        .getVisitScoreDetailApi(param)
        .then((res) => {
          this.loading = false
          this.formData = res.body
          console.log('formData ------>', this.formData)
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 保存数据
    save() {
      this.saveData()
    },
    saveData() {
      const data = this.$refs.scoreList.getData()
      if (!data) {
        return
      }
      this.formData.listVisitScoreGroup = data
      this.$loading(this.options)
      this.$api
        .saveVisitScoreApi(this.formData)
        .then(() => {
          this.$loading(this.options).close()
          this.saveOkQuestion()
        })
        .catch(() => {
          this.$loading(this.options).close()
        })
    },
    // validate() {
    //   let result = this.formData.listVisitScoreGroup
    //     .map((g) => g.listVisitScoreItem.filter((t) => !t.visitItemValue))
    //     .filter((t) => t && t.length)
    //   return !result.length
    // },
    del() {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'

      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api
          .delVisitScoreApi({ visitScoreCode: this.visitScoreCode })
          .then(() => {
            this.saveOkQuestion()
          })
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('INDEX.tips_operate_ok') || '操作成功',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          },
        }
      )
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
      // history.back()
    },
    // 重置表单数据
    resetData() {
      this.formData = {}
    },
  },
}
</script>
<style lang="scss" scoped>
.table-text {
  color: #606266;
  font-size: 14px;
}
.label-title {
  color: #606266;
  font-size: 16px;
  font-weight: 500;
}

::v-deep .tip_form_item .el-form-item__label {
  float: inherit;
}
</style>
